import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import React from 'react';
import { Client } from 'acscp/components/auth/client';
import { TripCounter } from 'acscp/components/bookings/tripCounter';
import { ContactAccountManager } from 'acscp/components/auth/contactAccountManager';
import style from './mainMenu.module.scss';
import { Logo } from 'acscp/components/common/logo';
import { AppState, Menu } from 'acscp/store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Background, Row } from 'acscp/components/common/row';
import { MenuIcon } from 'acscp/components/common/icons/menuIcon';
import { userCanAccessCharters, userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { SetOpenMenu } from 'acscp/actions';
import classNames from 'classnames';

interface MainMenuStateProps {
    isAnonymousUser: boolean;
    canAccessCharters: boolean;
}

interface MainMenuDispatchProps {
    openHamburgerMenu: () => void;
}

interface MainMenuOwnProps {
    tripCounterOnSamePage: boolean;
    useStickyHeader: boolean;
}

export class MainMenuPresentational extends PresentationComponentBase<
    MainMenuOwnProps, MainMenuStateProps, MainMenuDispatchProps, {}> {

    render(): JSX.Element {
        return (
            <div className={classNames(style.MainMenu, {[style.StickyHeader]: this.props.useStickyHeader})}>
                <Row background={Background.White}>
                    <div className={style.Row}>
                        <div className={style.Hamburger}>
                            <a
                                href="javascript:;"
                                className={style.HamburgerButton}
                                onClick={this.props.openHamburgerMenu}
                            >
                                <MenuIcon />
                                <FormattedMessage
                                    id={'mobile.components.hamburgerMenu.menu'}
                                    defaultMessage={'MENU'}
                                />
                            </a>
                        </div>
                        <div className={style.Logo}>
                            <Logo />
                        </div>
                        {!this.props.isAnonymousUser && <div className={style.Client}>
                            <Client />
                        </div>}
                        {(!this.props.isAnonymousUser && this.props.canAccessCharters) &&
                            <div className={style.TripCounter}>
                                <TripCounter
                                    onSamePage={this.props.tripCounterOnSamePage}
                                />
                            </div>}
                        <div className={style.ContactAccountManager}>
                            <ContactAccountManager />
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): MainMenuDispatchProps {
    return {
        openHamburgerMenu: () => dispatch(new SetOpenMenu(Menu.Hamburger)),
    };
}

function mapStateToProps(state: AppState, ownProps: {}): MainMenuStateProps {
    return {
        isAnonymousUser: !userIsLoggedIn(state.auth),
        canAccessCharters: userCanAccessCharters(state.auth),
    };
}

export const MainMenu = connect(mapStateToProps, mapDispatchToProps)(MainMenuPresentational);
